'use es6';

import PropTypes from 'prop-types';
import React from 'react';
import UIModal from 'UIComponents/dialog/UIModal';
import UIIllustration from 'UIComponents/image/UIIllustration';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogHeaderImage from 'UIComponents/dialog/UIDialogHeaderImage';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import H2 from 'UIComponents/elements/headings/H2';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';

var SuccessModal = function SuccessModal(_ref) {
  var header = _ref.header,
      body = _ref.body,
      footer = _ref.footer,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 600 : _ref$width;
  return React.createElement(UIModal, {
    centered: true,
    use: "success",
    width: width
  }, React.createElement(UIDialogHeaderImage, {
    offsetBottom: 23,
    offsetTop: 99
  }, React.createElement(UIIllustration, {
    name: "success",
    width: 118
  })), React.createElement(UIDialogHeader, {
    className: "p-top-0"
  }, React.createElement(H2, null, header)), React.createElement(UIDialogBody, null, body), React.createElement(UIDialogFooter, null, footer));
};

SuccessModal.propTypes = {
  header: PropTypes.node,
  body: PropTypes.node,
  footer: PropTypes.node,
  width: PropTypes.number
};
export default SuccessModal;